import { combineReducers } from 'redux'
import session from './session'
import elementsUI from './elementsUI'
import activePatient from './activePatient'

const rootReducer = combineReducers({
	session,
	elementsUI,
	activePatient
})

export default rootReducer
